/* unplugin-vue-components disabled */import script from "./BlackTableBlock.vue?vue&type=script&setup=true&lang=ts"
export * from "./BlackTableBlock.vue?vue&type=script&setup=true&lang=ts"

import "./BlackTableBlock.vue?vue&type=style&index=0&id=66f5e2f2&scoped=true&lang=less"

import exportComponent from "/data/jenkins/workspace/infra_PayAdminWeb/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-66f5e2f2"]])

export default __exports__